import classNames from "classnames";
import React from "react";
import * as RRF from "react-redux-form";

import "./FieldError.scss";

/**
 * react-redux-form doesn't export this, types source from docs http://davidkpiano.github.io/react-redux-form/docs/api/Errors.html
 */
interface ErrorsProps {
  /**
   * react-redux-form model to show errors for
   */
  model: string;

  /**
   * Messages to show for errors, keyed by the identifier used in the validator
   */
  messages: RRF.ErrorsComponentMessages;

  /**
   * Additional classNames to combine with .rrf-errors
   */
  className?: string;

  /**
   * Customise the parent wrapper. Default: <ul>
   */
  wrapper?: string | ((children: React.ReactNode) => JSX.Element);

  /**
   * Customise the parent wrapper. Default: <ul>
   */
  component?: string | ((children: React.ReactNode) => JSX.Element);

  /**
   * Control when errors should be shown, if there are any.
   */
  show?: boolean | ((field: RRF.FieldState) => boolean);
}

/**
 * Wrapper for RRF Errors component so we can have a consistent className for styling
 */
export const FieldError = ({ className, ...rest }: ErrorsProps) => (
  <RRF.Errors className={classNames("rrf-errors", className)}
    wrapper="ul"
    component="li"
    show={field => field.submitFailed || field.touched && field.errors}
    {...rest}
  />
);
